import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';
import { getSearchListData } from '../../services/ftp.service';

const FTPServers = ({
  id,
  name,
  label,
  defaultValue,
  multiple,
  disabled,
  onChange,
  sx,
  error,
  reloadData,
}) => {
  const selectedValue = defaultValue || (multiple ? [] : null);

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(selectedValue);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    getSearchListData()
      .then((res) => {
        setOptions(res.data || []);
        setLoading(false);
      })
      .catch(() => {
        // upon error, show loading only
      });
  }, [reloadData]);

  useEffect(() => {
    setValue(selectedValue);
  }, [defaultValue]);

  return (
    <Autocomplete
      id={id}
      name={name}
      options={options}
      getOptionLabel={(option) => option.name}
      sx={sx}
      value={value}
      onChange={(e, v) => {
        setValue(v);
        onChange(v);
      }}
      inputValue={inputValue}
      onInputChange={(e, v) => {
        setInputValue(v);
      }}
      multiple={multiple}
      disabled={disabled}
      loading={loading}
      isOptionEqualToValue={(op, vl) => op.id === vl.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error !== ''}
          helperText={error}
          variant="filled"
        />
      )}
    />
  );
};

FTPServers.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  reloadData: PropTypes.number,
};
FTPServers.defaultProps = {
  multiple: false,
  disabled: false,
  sx: {},
  defaultValue: null,
  error: '',
  reloadData: null,
};

export default FTPServers;
